import React, { useState, useEffect } from 'react';
import './Schools.css';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import { apiPath, apiKey } from '../../constants';

const styles = (theme) => ({
    root: {
        margin: 0,
        padding: theme.spacing(2),
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },
});

const DialogTitle = withStyles(styles)((props) => {
    const { children, classes, onClose, ...other } = props;
    return (
        <MuiDialogTitle disableTypography className={classes.root} {...other}>
            <Typography variant="h6">{children}</Typography>
            {onClose ? (
                <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
                    <CloseIcon />
                </IconButton>
            ) : null}
        </MuiDialogTitle>
    );
});

const DialogContent = withStyles((theme) => ({
    root: {
        padding: theme.spacing(2),
    },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
    root: {
        margin: 0,
        padding: theme.spacing(1),
    },
}))(MuiDialogActions);

const useStyles = makeStyles((theme) => ({
    root: {
        '& > *': {
            margin: theme.spacing(1),
            width: '50ch',
        },
    },
}));

function Schools() {
    const [loading, setLoading] = useState(true);
    const [schools, setSchools] = useState([]);
    const [singleSch, setsingleSch] = useState([]);
    const [openSchDetails, setOpenSchDetails] = useState(false);

    const handleSchDetailsOpen = () => {
        setOpenSchDetails(true);
    }

    const handleSchDetailsClose = () => {
        setOpenSchDetails(false);
    }

    const classes = useStyles();

    useEffect(() => {
        async function fetchData() {
            const response = await fetch(apiPath+'schools', {
                method: 'GET',
                headers: new Headers({
                    'Content-Type': 'application/json',
                    'x-api-key': apiKey
                }),
            })
            const result = await response.json();
            console.log(result)
            setSchools(result)
            setLoading(false)
        }
        fetchData();
    }, [])

    const viewSingleSchool = (schCode) => {
        var url = apiPath+'schools/' + schCode
        fetch(url, {
            method: 'GET',
            headers: new Headers({
                'Content-Type': 'application/json',
                'x-api-key': apiKey
            }),
        })
            .then(response => response.json())
            .then(data => {
                setsingleSch(data)
                handleSchDetailsOpen();
            })
            .catch(error => {
                console.log('There was an error!', error);
            });
    }

    return (
        <div className="School_main">
            {
                loading ?
                    <img className="schoolloadingSymbol" src={require('../../images/loading2.gif')} alt="loading" />
                    :
                    <table className="fixed_header">
                        <thead>
                            <tr>
                                <th className="schoolTabl_id">No.</th>
                                <th className="schoolTabl_sch">School Name</th>
                                <th className="schoolTabl_shname">Short Name</th>
                                <th className="schoolTabl_active">Active</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                schools && schools.map((school_item, index) => {
                                    return (
                                        <tr key={school_item.school_code}
                                        // onClick={() => viewSingleSchool(school_item.school_code)}
                                        >
                                            <td className="schoolTabl_id">{index + 1}</td>
                                            <td className="schoolTabl_sch">{school_item.school_name}</td>
                                            <td className="schoolTabl_shname">{school_item.school_code}</td>
                                            {
                                                school_item.is_active === 1 ?
                                                    <td className="schoolTabl_active">Yes</td> : <td className="schoolTabl_active">False</td>
                                            }
                                        </tr>
                                    );
                                })
                            }
                        </tbody>
                    </table>
            }
            <div>
                <Dialog onClose={handleSchDetailsClose} aria-labelledby="customized-dialog-title" open={openSchDetails}>
                    <DialogTitle id="customized-dialog-title" onClose={handleSchDetailsClose}>
                        School Details
                    </DialogTitle>
                    <DialogContent dividers style={{ padding: '0vw 4vw' }}>
                        {
                            singleSch && singleSch.map((details) => {
                                return (
                                    <div className="school_schDetails" key={details.school_code}>
                                        <p className="schools_schName">{details.school_name}</p>
                                        <li className="schools_schAllDet"><span className="schools_schHeadingOrg">Organization Name</span>: {details.lms_organization_name}</li>
                                        <li className="schools_schAllDet"><span className="schools_schEmail">Email</span>: {details.email}</li>
                                        <li className="schools_schAllDet"><span className="schools_schContact">Contact Number</span>: {details.contact_number}</li>
                                        <li className="schools_schAllDet"><span className="schools_schWebsite">Website</span>: {details.website}</li>
                                        <li className="schools_schAllDet"><span className="schools_schCode">School Code</span>: {details.school_code}</li>
                                        {
                                            details.is_active === 1 ?
                                                <li className="schools_schAllDet"><span className="schools_SchActive">Active</span>: True</li>
                                                :
                                                <li className="schools_schAllDet"><span className="schools_SchActive">Active</span>: False</li>
                                        }
                                        <li className="schools_schAllDet"><span className="schools_Schsubdomain">Subdomain</span>: {details.lms_subdomain}</li>
                                    </div>
                                );
                            })
                        }
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleSchDetailsClose}>
                            Close
                        </Button>
                    </DialogActions>
                </Dialog>
            </div>
        </div>
    );
}

export default Schools;